<template>
  <div class="api-audit-page">
    <h1>接口调用记录</h1>
    <div class="audit-card">
      <el-form :inline="true" :model="query" size="small" @submit.native.prevent="search">
        <el-form-item label="调用时间">
          <el-date-picker v-model="query.timeRange" type="datetimerange" value-format="timestamp" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" />
        </el-form-item>
        <el-form-item label="应用">
          <el-select v-model="query.appId" filterable remote clearable :remote-method="searchApplications" :loading="applicationsLoading" placeholder="搜索应用名称">
            <el-option v-for="app in applicationOptions" :key="app.appId" :value="app.appId" :label="applicationLabel(app)" />
          </el-select>
          <el-button v-if="applicationOptions.length < applicationTotal" type="text" :loading="applicationsLoading" @click="loadMoreApplications">更多应用</el-button>
        </el-form-item>
        <el-form-item label="请求ID"><el-input v-model.trim="query.requestId" maxlength="36" clearable placeholder="完整请求ID" /></el-form-item>
        <el-form-item label="请求方法"><el-select v-model="query.httpMethod" clearable placeholder="全部"><el-option v-for="method in methods" :key="method" :label="method" :value="method" /></el-select></el-form-item>
        <el-form-item label="接口路径"><el-input v-model.trim="query.requestPath" maxlength="500" clearable placeholder="包含的路径" /></el-form-item>
        <el-form-item label="结果"><el-select v-model="query.result"><el-option label="全部" value="ALL" /><el-option label="成功" value="SUCCESS" /><el-option label="失败" value="FAILURE" /></el-select></el-form-item>
        <el-form-item label="HTTP状态"><el-input v-model.trim="query.httpStatus" maxlength="3" clearable placeholder="例如401" /></el-form-item>
        <el-form-item label="结果码"><el-input v-model.trim="query.resultCode" maxlength="100" clearable /></el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="search">查询</el-button><el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button></el-form-item>
      </el-form>
      <p class="audit-hint">默认查询最近7天，单次最多31天；记录时间按北京时间显示。</p>
      <p v-if="applicationsError" class="audit-error">{{ applicationsError }} <el-button type="text" size="mini" @click="searchApplications(applicationKeyword)">重试应用查询</el-button></p>
    </div>
    <div class="audit-card">
      <div v-if="listError" class="audit-error" role="alert">{{ listError }} <el-button type="text" @click="fetchList">重新加载</el-button></div>
      <el-table v-loading="loading" :data="list" row-key="id" :empty-text="tableEmptyText">
        <el-table-column label="调用时间" width="165"><template slot-scope="{ row }">{{ formatTime(row.createTime) }}</template></el-table-column>
        <el-table-column label="应用" min-width="140" show-overflow-tooltip><template slot-scope="{ row }">{{ row.appName || '未识别应用' }}</template></el-table-column>
        <el-table-column label="所属账号" min-width="140" show-overflow-tooltip><template slot-scope="{ row }">{{ accountLabel(row) }}</template></el-table-column>
        <el-table-column prop="httpMethod" label="方法" width="85" />
        <el-table-column prop="requestPath" label="接口路径" min-width="230" show-overflow-tooltip />
        <el-table-column label="HTTP状态" width="105"><template slot-scope="{ row }"><el-tag :type="Number(row.httpStatus) >= 400 ? 'danger' : 'success'" size="small">{{ row.httpStatus == null ? '-' : row.httpStatus }}</el-tag></template></el-table-column>
        <el-table-column prop="resultCode" label="结果码" min-width="150" show-overflow-tooltip />
        <el-table-column label="耗时" width="100"><template slot-scope="{ row }">{{ row.durationMs == null ? '-' : row.durationMs + ' ms' }}</template></el-table-column>
        <el-table-column prop="requestId" label="请求ID" min-width="220" show-overflow-tooltip />
        <el-table-column label="操作" width="80" fixed="right"><template slot-scope="{ row }"><el-button type="text" size="small" @click="openDetail(row)">详情</el-button></template></el-table-column>
      </el-table>
      <div class="audit-pagination"><el-pagination :current-page="pageNum" :page-size="pageSize" :total="total" :page-sizes="[20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" background @current-change="changePage" @size-change="changeSize" /></div>
    </div>
    <el-drawer title="接口调用详情" :visible.sync="detailVisible" size="560px" @close="closeDetail">
      <div v-loading="detailLoading" class="audit-detail">
        <div v-if="detailError" class="audit-error" role="alert">{{ detailError }} <el-button type="text" @click="fetchDetail">重试</el-button></div>
        <el-descriptions v-if="detail.id" :column="1" border>
          <el-descriptions-item label="请求ID">{{ detail.requestId }}</el-descriptions-item>
          <el-descriptions-item label="调用时间">{{ formatTime(detail.createTime) }}</el-descriptions-item>
          <el-descriptions-item label="应用">{{ detail.appName || '未识别应用' }}</el-descriptions-item>
          <el-descriptions-item label="所属账号">{{ accountLabel(detail) }}</el-descriptions-item>
          <el-descriptions-item label="请求方法">{{ detail.httpMethod }}</el-descriptions-item>
          <el-descriptions-item label="接口路径">{{ detail.requestPath }}</el-descriptions-item>
          <el-descriptions-item label="业务操作">{{ detail.apiOperation || '-' }}</el-descriptions-item>
          <el-descriptions-item label="HTTP状态">{{ detail.httpStatus }}</el-descriptions-item>
          <el-descriptions-item label="结果码">{{ detail.resultCode || '-' }}</el-descriptions-item>
          <el-descriptions-item label="耗时">{{ detail.durationMs == null ? '-' : detail.durationMs + ' ms' }}</el-descriptions-item>
          <el-descriptions-item label="资源类型">{{ detail.resourceType || '-' }}</el-descriptions-item>
          <el-descriptions-item label="资源ID">{{ detail.resourceId || '-' }}</el-descriptions-item>
          <el-descriptions-item label="来源IP">{{ detail.sourceIp || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import request from '@/utils/request'

const emptyQuery = () => {
  const now = Date.now()
  return { timeRange: [now - 7 * 86400000, now], appId: '', requestId: '', httpMethod: '', requestPath: '', result: 'ALL', httpStatus: '', resultCode: '' }
}
const pageData = response => {
  const data = response && response.data
  if (!data || !Array.isArray(data.items) || !Number.isFinite(Number(data.total))) throw new Error('查询响应格式不正确，请重试')
  return data
}

export default {
  name: 'ApiAuditManage',
  data() {
    return {
      query: emptyQuery(), methods: ['GET', 'POST', 'PUT', 'DELETE', 'PATCH', 'HEAD', 'OPTIONS'],
      list: [], total: 0, pageNum: 1, pageSize: 20, loading: false, listError: '', listRequestId: 0,
      applicationOptions: [], applicationTotal: 0, applicationPage: 0, applicationKeyword: '', applicationsLoading: false, applicationsError: '', applicationRequestId: 0,
      detail: {}, detailId: '', detailVisible: false, detailLoading: false, detailError: '', detailRequestId: 0
    }
  },
  computed: {
    tableEmptyText() { return this.listError ? '查询失败，请重试' : this.loading ? '正在加载调用记录' : '当前条件下没有调用记录' }
  },
  created() { this.fetchList(); this.searchApplications('') },
  beforeDestroy() { this.listRequestId += 1; this.applicationRequestId += 1; this.detailRequestId += 1 },
  methods: {
    buildParams() {
      const range = this.query.timeRange
      if (!Array.isArray(range) || range.length !== 2 || range.some(value => value === null || value === '' || !Number.isFinite(Number(value)))) throw new Error('请选择完整的起止时间')
      const [start, end] = range.map(Number)
      if (start > end) throw new Error('开始时间不能晚于结束时间')
      if (end - start > 31 * 86400000) throw new Error('单次查询时间不能超过31天')
      const params = { startTime: new Date(start).toISOString(), endTime: new Date(end).toISOString(), pageNum: this.pageNum, pageSize: this.pageSize }
      for (const key of ['appId', 'requestId', 'httpMethod', 'requestPath', 'result', 'resultCode']) {
        if (this.query[key] !== '' && this.query[key] != null) params[key] = this.query[key]
      }
      if (this.query.httpStatus !== '' && this.query.httpStatus != null) {
        if (!/^\d{3}$/.test(String(this.query.httpStatus)) || Number(this.query.httpStatus) < 100 || Number(this.query.httpStatus) > 599) throw new Error('HTTP状态须为100至599的整数')
        params.httpStatus = Number(this.query.httpStatus)
      }
      return params
    },
    search() { this.pageNum = 1; return this.fetchList() },
    resetQuery() { this.query = emptyQuery(); return this.search() },
    changePage(page) { this.pageNum = page; return this.fetchList() },
    changeSize(size) { this.pageSize = size; return this.search() },
    async fetchList() {
      const id = ++this.listRequestId
      let params
      try { params = this.buildParams() } catch (error) { this.listError = error.message; this.loading = false; return }
      this.loading = true
      this.listError = ''
      try {
        const response = await request.get('/webserver/system/api-audits', { params })
        if (id !== this.listRequestId) return
        const data = pageData(response)
        this.list = data.items
        this.total = Number(data.total)
      } catch (error) { if (id === this.listRequestId) this.listError = error.msg || error.message || '读取调用记录失败' }
      finally { if (id === this.listRequestId) this.loading = false }
    },
    searchApplications(keyword) {
      this.applicationKeyword = String(keyword || '')
      this.applicationOptions = []
      this.applicationTotal = 0
      this.applicationPage = 0
      return this.fetchApplications(1)
    },
    loadMoreApplications() {
      if (this.applicationsLoading || this.applicationOptions.length >= this.applicationTotal) return
      return this.fetchApplications(this.applicationPage + 1)
    },
    async fetchApplications(page) {
      const id = ++this.applicationRequestId
      this.applicationsLoading = true
      this.applicationsError = ''
      try {
        const response = await request.get('/webserver/system/api-audits/applications', { params: { name: this.applicationKeyword, pageNum: page, pageSize: 20 } })
        if (id !== this.applicationRequestId) return
        const data = pageData(response)
        const previous = page === 1 ? [] : this.applicationOptions
        const seen = new Set(previous.map(item => String(item.appId)))
        this.applicationOptions = previous.concat(data.items.filter(item => { const key = String(item.appId); if (seen.has(key)) return false; seen.add(key); return true }))
        this.applicationTotal = Number(data.total)
        this.applicationPage = page
      } catch (error) { if (id === this.applicationRequestId) this.applicationsError = error.msg || error.message || '读取应用失败' }
      finally { if (id === this.applicationRequestId) this.applicationsLoading = false }
    },
    applicationLabel(app) { return `${app.appName || app.appId}${Number(app.status) === 0 ? '（停用）' : ''}${app.accountDeleted ? ' · 已删除账号' : ''}` },
    accountLabel(row) { return row.accountDeleted ? `已删除账号（${row.accountId || '-'}）` : row.accountName || row.accountId || '-' },
    openDetail(row) { this.detailId = String(row.id); this.detailVisible = true; this.detail = {}; return this.fetchDetail() },
    async fetchDetail() {
      if (!this.detailVisible || !this.detailId) return
      const id = ++this.detailRequestId
      this.detailLoading = true
      this.detailError = ''
      try {
        const response = await request.get(`/webserver/system/api-audits/${encodeURIComponent(this.detailId)}`)
        if (id !== this.detailRequestId || !this.detailVisible) return
        this.detail = response.data
      } catch (error) { if (id === this.detailRequestId && this.detailVisible) this.detailError = error.msg || error.message || '读取详情失败' }
      finally { if (id === this.detailRequestId) this.detailLoading = false }
    },
    closeDetail() { this.detailVisible = false; this.detailRequestId += 1; this.detailLoading = false },
    formatTime(value) {
      if (value == null || value === '') return '-'
      // 兼容旧时间文本；展示固定北京时间，不依赖浏览器所在时区。
      const text = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(value) ? value.replace(' ', 'T') + '+08:00' : value
      const millis = new Date(text).getTime()
      return Number.isFinite(millis) ? new Date(millis + 8 * 3600000).toISOString().slice(0, 19).replace('T', ' ') : '-'
    }
  }
}
</script>

<style scoped>
.api-audit-page { padding: 16px 18px; background: #f4f6f9; min-height: 100%; box-sizing: border-box; }
.api-audit-page h1 { margin: 0 0 16px; font-size: 18px; font-weight: 500; color: #303133; }
.audit-card { margin-bottom: 14px; padding: 16px; background: #fff; border: 1px solid #e6ebf2; border-radius: 4px; }
.audit-card .el-form-item { margin-bottom: 12px; }
.audit-hint { margin: 0; font-size: 12px; color: #909399; }
.audit-error { margin: 0 0 10px; font-size: 13px; color: #f56c6c; }
.audit-pagination { display: flex; justify-content: flex-end; margin-top: 16px; }
.audit-detail { padding: 0 20px 24px; overflow-wrap: anywhere; }
</style>
